import authPartner from '../../fields/other/authPartner';

export const QUERY_GET_AUTH_PARTNER = /* GraphQL */ `
	query ($id: String!) {
		getAuthPartner(id: $id) {
            ${authPartner}
        }
	}
`;
